import RailsApp from '../rails_app';

document.addEventListener('DOMContentLoaded', RailsApp.run());
